// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThirdBlock_root__rbXJP {
  padding: 40px 0;
}
.ThirdBlock_root__rbXJP .ThirdBlock_container__6kpzw {
  margin-bottom: 20px;
}
.ThirdBlock_root__rbXJP .ThirdBlock_container__6kpzw p {
  font-size: 26px;
  font-weight: bold;
  color: #00377c;
}
.ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod {
  position: relative;
  width: 100%;
  height: 100px;
  margin: auto;
  overflow: hidden;
}
.ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod::before, .ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod::after {
  content: "";
  position: absolute;
  width: 200px;
  height: 100px;
  z-index: 2;
}
.ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod::after {
  top: 0;
  right: 0;
  transform: rotateZ(180deg);
}
.ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod::before {
  top: 0;
  left: 0;
}
.ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod .ThirdBlock_slideTrack__XbN2X {
  display: flex;
  width: 13500px;
  animation: ThirdBlock_scroll__\\+Av1e 70s linear infinite;
}
.ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod .ThirdBlock_slide__pxMxc {
  width: 250px;
  height: 100px;
}
@keyframes ThirdBlock_scroll__\\+Av1e {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-6750px);
  }
}

@media (max-width: 768px) {
  .ThirdBlock_root__rbXJP {
    padding: 20px 0;
  }
  .ThirdBlock_root__rbXJP .ThirdBlock_container__6kpzw {
    margin-bottom: 10px;
  }
  .ThirdBlock_root__rbXJP .ThirdBlock_container__6kpzw p {
    font-size: 18px;
  }
  .ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod {
    height: 80px;
    margin: auto;
    overflow: hidden;
    position: relative;
    width: 100%;
  }
  .ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod::before, .ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod::after {
    content: "";
    position: absolute;
    width: 170px;
    height: 80px;
    z-index: 2;
  }
  .ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod .ThirdBlock_slideTrack__XbN2X {
    animation: ThirdBlock_scroll__\\+Av1e 60s linear infinite;
    display: flex;
    width: 9180px;
  }
  .ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod .ThirdBlock_slide__pxMxc {
    width: 170px;
    height: 80px;
  }
  .ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod .ThirdBlock_slide__pxMxc img {
    width: 170px;
    height: 80px;
  }
  @keyframes ThirdBlock_scroll__\\+Av1e {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-4590px);
    }
  }
}
@media (max-width: 500px) {
  .ThirdBlock_root__rbXJP .ThirdBlock_container__6kpzw p {
    font-size: 16px;
  }
  .ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod {
    height: 50px;
    margin: auto;
    overflow: hidden;
    position: relative;
    width: 100%;
  }
  .ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod::before, .ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod::after {
    content: "";
    position: absolute;
    width: 100px;
    height: 50px;
    z-index: 2;
  }
  .ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod .ThirdBlock_slideTrack__XbN2X {
    animation: ThirdBlock_scroll__\\+Av1e 50s linear infinite;
    display: flex;
    width: 5400px;
  }
  .ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod .ThirdBlock_slide__pxMxc {
    width: 100px;
    height: 50px;
  }
  .ThirdBlock_root__rbXJP .ThirdBlock_slider__8pxod .ThirdBlock_slide__pxMxc img {
    width: 100px;
    height: 50px;
  }
  @keyframes ThirdBlock_scroll__\\+Av1e {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-2700px);
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MainBlock/ThirdBlock/ThirdBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,eAAA;EAEA,iBAAA;EACA,cAAA;AAAN;AAIE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAFJ;AAII;EAEE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AAHN;AAMI;EACE,MAAA;EACA,QAAA;EACA,0BAAA;AAJN;AAOI;EACE,MAAA;EACA,OAAA;AALN;AAQI;EACE,aAAA;EACA,cAAA;EACA,wDAAA;AANN;AASI;EACE,YAAA;EACA,aAAA;AAPN;AAWE;EACE;IACE,wBAAA;EATJ;EAWE;IACE,8BAAA;EATJ;AACF;;AAaA;EACE;IACE,eAAA;EAVF;EAYE;IACE,mBAAA;EAVJ;EAYI;IACE,eAAA;EAVN;EAcE;IACE,YAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,WAAA;EAZJ;EAcI;IAEE,WAAA;IACA,kBAAA;IACA,YAAA;IACA,YAAA;IACA,UAAA;EAbN;EAgBI;IACE,wDAAA;IACA,aAAA;IACA,aAAA;EAdN;EAiBI;IACE,YAAA;IACA,YAAA;EAfN;EAiBM;IACE,YAAA;IACA,YAAA;EAfR;EAoBE;IACE;MACE,wBAAA;IAlBJ;IAoBE;MACE,8BAAA;IAlBJ;EACF;AACF;AAsBA;EAGM;IACE,eAAA;EAtBN;EA0BE;IACE,YAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,WAAA;EAxBJ;EA0BI;IAEE,WAAA;IACA,kBAAA;IACA,YAAA;IACA,YAAA;IACA,UAAA;EAzBN;EA4BI;IACE,wDAAA;IACA,aAAA;IACA,aAAA;EA1BN;EA6BI;IACE,YAAA;IACA,YAAA;EA3BN;EA6BM;IACE,YAAA;IACA,YAAA;EA3BR;EAgCE;IACE;MACE,wBAAA;IA9BJ;IAgCE;MACE,8BAAA;IA9BJ;EACF;AACF","sourcesContent":[".root {\n  padding: 40px 0;\n\n  .container {\n    margin-bottom: 20px;\n\n    p {\n      font-size: 26px;\n      // font-size: clamp(18px, 4vw, 36px);\n      font-weight: bold;\n      color: #00377c;\n    }\n  }\n\n  .slider {\n    position: relative;\n    width: 100%;\n    height: 100px;\n    margin: auto;\n    overflow: hidden;\n\n    &::before,\n    &::after {\n      content: \"\";\n      position: absolute;\n      width: 200px;\n      height: 100px;\n      z-index: 2;\n    }\n\n    &::after {\n      top: 0;\n      right: 0;\n      transform: rotateZ(180deg);\n    }\n\n    &::before {\n      top: 0;\n      left: 0;\n    }\n\n    .slideTrack {\n      display: flex;\n      width: calc(250px * 54);\n      animation: scroll 70s linear infinite;\n    }\n\n    .slide {\n      width: 250px;\n      height: 100px;\n    }\n  }\n\n  @keyframes scroll {\n    0% {\n      transform: translateX(0);\n    }\n    100% {\n      transform: translateX(calc(-250px * 27));\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    padding: 20px 0;\n\n    .container {\n      margin-bottom: 10px;\n\n      p {\n        font-size: 18px;\n      }\n    }\n\n    .slider {\n      height: 80px;\n      margin: auto;\n      overflow: hidden;\n      position: relative;\n      width: 100%;\n\n      &::before,\n      &::after {\n        content: \"\";\n        position: absolute;\n        width: 170px;\n        height: 80px;\n        z-index: 2;\n      }\n\n      .slideTrack {\n        animation: scroll 60s linear infinite;\n        display: flex;\n        width: calc(170px * 54);\n      }\n\n      .slide {\n        width: 170px;\n        height: 80px;\n\n        img {\n          width: 170px;\n          height: 80px;\n        }\n      }\n    }\n\n    @keyframes scroll {\n      0% {\n        transform: translateX(0);\n      }\n      100% {\n        transform: translateX(calc(-170px * 27));\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .root {\n    .container {\n      p {\n        font-size: 16px;\n      }\n    }\n\n    .slider {\n      height: 50px;\n      margin: auto;\n      overflow: hidden;\n      position: relative;\n      width: 100%;\n\n      &::before,\n      &::after {\n        content: \"\";\n        position: absolute;\n        width: 100px;\n        height: 50px;\n        z-index: 2;\n      }\n\n      .slideTrack {\n        animation: scroll 50s linear infinite;\n        display: flex;\n        width: calc(100px * 54);\n      }\n\n      .slide {\n        width: 100px;\n        height: 50px;\n\n        img {\n          width: 100px;\n          height: 50px;\n        }\n      }\n    }\n\n    @keyframes scroll {\n      0% {\n        transform: translateX(0);\n      }\n      100% {\n        transform: translateX(calc(-100px * 27));\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ThirdBlock_root__rbXJP`,
	"container": `ThirdBlock_container__6kpzw`,
	"slider": `ThirdBlock_slider__8pxod`,
	"slideTrack": `ThirdBlock_slideTrack__XbN2X`,
	"scroll": `ThirdBlock_scroll__+Av1e`,
	"slide": `ThirdBlock_slide__pxMxc`
};
export default ___CSS_LOADER_EXPORT___;
